import 'assets/scss/index.scss'
import 'regenerator-runtime/runtime'
import 'core-js/stable'
import 'intersection-observer'
import 'swiper/swiper.scss'
import 'swiper/components/lazy/lazy.scss'

import { AppProps } from 'next/app'

import DefaultLayout from '@ui/layouts/default'
import MyHead from '@ui/components/next/MyHead'
import { OrderProvider } from '@ui/contexts'
import { initSentry } from '@ui/analytics'
import CountExpiredTime from '@ui/components/shared/CountExpiredTime'
import { NEXT_DATA } from 'next/dist/shared/lib/utils'
import Error from './_error'
import { initializeClientState } from '@ui/helpers/initializeState'

declare global {
  interface Window {
    __NEXT_DATA__: NEXT_DATA
    initMap?: () => void
  }
}

if (typeof window !== 'undefined') {
  initializeClientState()
}

initSentry()
function MyApp({ Component, pageProps }: AppProps) {
  if (pageProps?.statusCode >= 400) return <Error statusCode={pageProps.statusCode} />
  return (
    <>
      <MyHead />
      <DefaultLayout>
        <OrderProvider>
          <CountExpiredTime />
          <Component {...pageProps} />
        </OrderProvider>
      </DefaultLayout>
    </>
  )
}

export default MyApp
